import { Button, PageHeader } from '@/components';
import { useAuth } from '@/features/auth/AuthProvider';
import {
  type DeviceFilterParams,
  DeviceFilters,
  filtersFromParams,
} from '@/features/devices/DeviceFilters';
import { DevicesTable } from '@/features/devices/DevicesTable';
import { RegisterDeviceModal } from '@/features/devices/RegisterDeviceModal';
import { useSearchParams } from '@solidjs/router';
import { Show, createMemo, createSignal } from 'solid-js';

export default function DevicesIndex() {
  const { session } = useAuth();
  const [params] = useSearchParams<DeviceFilterParams>();
  const [showRegister, setShowRegister] = createSignal(false);
  const filters = createMemo(() => filtersFromParams(params));
  const canRegister = () => session()?.permissions.has('devices:register') ?? false;

  return (
    <section>
      <PageHeader
        title="Devices"
        actions={
          <Show when={canRegister()}>
            <Button onClick={() => setShowRegister(true)}>Register device</Button>
          </Show>
        }
      />
      <div class="mx-auto max-w-6xl p-6">
        <DeviceFilters />
        <DevicesTable filters={filters} />
        <RegisterDeviceModal open={showRegister()} onClose={() => setShowRegister(false)} />
      </div>
    </section>
  );
}
